// extracted by mini-css-extract-plugin
module.exports = {"root":"_a6af4b","title":"_347195","lastUpdated":"_e858ad","authorsContainer":"_9af1cb","contributorsContainer":"_df7fab"};